import React, {useState,useRef} from 'react'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import styles from './PendingSuccessButton.module.css'

const PendingSuccessButton = ({onClick,variant,size,children,...props})=>{
	const [status,setStatus] = useState('idle')
	const buttonRef = useRef()
	const onPending = ()=>{
		setStatus('pending')
		//remove focus on pending to hide tooltip
		if(buttonRef.current) buttonRef.current.blur()
	}
	const onSuccess = ()=>{
		setStatus('success')
		setTimeout(()=>{
			setStatus('idle')
		},1000)
	}

	const onFailed = ()=>{
		setStatus('failed')
		setTimeout(()=>{
			setStatus('idle')
		},1000)
	}
	return (
		<Button 
			{...props}
			ref={buttonRef}
			className={styles.PendingSuccessButton}
			onClick={()=>{
				//pass "api" to click handler
				onClick({onPending,onSuccess,onFailed})
			}}
			disabled={ status !== 'idle' }
			variant={ status === 'failed' ? 'outline-danger' : variant }
			size={ size }
		>
			<span className={[
				styles.Fade,
				status === 'idle'? styles.Show : styles.Hide
			].join(' ')}>
				{children}
			</span>
			<span className={[
				styles.Fade,
				status === 'pending'? styles.Show : styles.Hide
			].join(' ')}>
				<Spinner animation="border" size="sm"/>
			</span>
			<span className={[
				styles.Fade,
				status === 'success'? styles.Show : styles.Hide
			].join(' ')}>
				<i className="fas fa-check"/>
			</span>
			<span className={[
				styles.Fade,
				status === 'failed'? styles.Show : styles.Hide
			].join(' ')}>
				<i className="fas fa-times"/>
			</span>
		</Button>
	)
}

export default PendingSuccessButton